import Disclosure from "./Disclosure.vue";

export default Disclosure;
